import React, {useEffect} from "react";
import {Select as AntSelect, SelectProps} from "antd";
import * as api from "../../apis/common";
import {useRequest} from "ahooks";

interface Props extends SelectProps {
    type?: 'province' | 'city' | 'district',
    parent?: any
}

const levelMap: { [key: string]: number } = {
    "province": 1,
    "city": 2,
    "district": 3,
}

function AreaSelect(props: Omit<Props, "options">) {

    const {type = "province",
        parent,
        showSearch = true,
        optionFilterProp='children',
        filterOption=true,
        ...otherProps} = props

    const {run, data, loading} = useRequest(api.getAreaOption, {
        manual: true,
    })

    useEffect(() => {
        run(levelMap[type], parent)
    }, [type, parent])

    const options = data?.data.data

    return (
        <AntSelect loading={loading} {...otherProps} showSearch={showSearch} optionFilterProp={optionFilterProp} filterOption={filterOption}>
            {options?.map((item: any) => (
                <AntSelect.Option key={item.areaCode} value={item.areaCode}>{item.areaName}</AntSelect.Option>
            ))}
        </AntSelect>
    )
}

export default AreaSelect
